import { XMarkIcon } from "@heroicons/react/24/outline";
import { useRef } from "react";
import { useClickOutsideBlock } from "../../helpers/useClickOutside";

export const ProfitAndLossTableItemDeleteInfoModal = ({
    isOpen,
    onClose,
    itemName,
    metricLabels = [],
    totalNameLabels = [],
}) => {
    const modalRef = useRef(null);
    useClickOutsideBlock(modalRef, onClose);

    const isUsedInForecastSettings = metricLabels.length > 0;
    const isUsedInTotalNames = totalNameLabels.length > 0;

    if (!isOpen) return null;

    return (
        <div aria-hidden="true" className="overflow-y-auto overflow-x-hidden fixed inset-0 z-[60] justify-center items-center">
            <div className="bg-gray-700 fixed inset-0 z-[60] opacity-30" />
            <div ref={modalRef} className="relative p-5 w-full max-w-2xl max-h-full bg-white border fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[70] rounded-md">
                <div className="flex justify-end">
                    <button
                        onClick={onClose}
                        className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-primary hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                    </button>
                </div>
                <div className="py-5">
                    <h4 className="text-xl font-semibold mb-4">
                        Cannot Delete P&amp;L Item
                    </h4>
                    <div className="space-y-4">
                        <p className="text-gray-700">
                            The item <span className="font-semibold">"{itemName}"</span> cannot be deleted because it is currently used
                            {isUsedInForecastSettings && isUsedInTotalNames
                                ? " in forecast settings and Profit & Loss total names settings."
                                : isUsedInForecastSettings
                                    ? " in forecast settings."
                                    : " in Profit & Loss total names settings."}
                        </p>

                        {metricLabels.length > 0 && (
                            <div>
                                <p className="text-sm font-medium text-gray-700 mb-2">
                                    Forecast metrics using this item:
                                </p>
                                <ul className="list-disc list-inside space-y-1">
                                    {metricLabels.map((label) => (
                                        <li key={label} className="text-gray-700">
                                            {label}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        {totalNameLabels.length > 0 && (
                            <div>
                                <p className="text-sm font-medium text-gray-700 mb-2">
                                    Profit &amp; Loss total cards using this item:
                                </p>
                                <ul className="list-disc list-inside space-y-1">
                                    {totalNameLabels.map((label) => (
                                        <li key={label} className="text-gray-700">
                                            {label}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}

                        <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
                            <p className="text-sm text-blue-800">
                                <span className="font-semibold">To delete this item:</span> You must update the related settings to use a different Profit &amp; Loss row first.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-2 pt-4 border-t">
                    <button
                        onClick={onClose}
                        className="min-w-20 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:mt-0 sm:w-auto sm:text-sm"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};
